import { useMemo } from "react";

import { useQuery } from "@tanstack/react-query";

import QueryKey from "@app/constants/QueryKeys.ts";
import { useMissionService } from "@app/services/api/useMissionService.ts";

export const useUserMissions = (email: string | undefined) => {
  const { fetchMissions } = useMissionService();

  const { data, error, isLoading } = useQuery({
    queryKey: [QueryKey.MISSIONS],
    queryFn: fetchMissions,
    enabled: !!email,
  });

  const missions = useMemo(
    () =>
      (data ?? [])
        .filter(
          (mission) =>
            mission.takimaUserEmail.toLowerCase() === email?.toLowerCase(),
        )
        .sort(
          (a, b) =>
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime(),
        ),
    [data, email],
  );

  return {
    missions,
    error,
    isLoading,
  };
};
